import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

interface CreateUserPayload {
  first_name: string;
  last_name: string;
  email: string;
  roles: string[];
}

export const useAddUser = () => {
  const queryClient = useQueryClient();

  const addUser = async (userData: CreateUserPayload): Promise<void> => {
    await Axios.post(POST_URL().createUser, userData);
  };

  return useMutation<void, AxiosError<BaseError>, CreateUserPayload>(
    (userData: CreateUserPayload) => addUser(userData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['users']);
      },
      useErrorBoundary: false
    }
  );
};
